export var PlatformName;
(function (PlatformName) {
    PlatformName["webos"] = "tv-webos";
    PlatformName["tizen"] = "sectv-tizen";
    PlatformName["web"] = "browser";
})(PlatformName || (PlatformName = {}));
export var DeviceModelName;
(function (DeviceModelName) {
    DeviceModelName["webos"] = "TV-WEBOS";
    DeviceModelName["tizen"] = "TV-TIZEN";
    DeviceModelName["web"] = "TV_WEB";
    DeviceModelName["android"] = "TV-ANDROID";
})(DeviceModelName || (DeviceModelName = {}));
